import styles from "./Footer.module.scss";
import React from "react";

 
// @ts-ignore
import emailScramble from "email-scramble";

interface FooterProps {
  mobile?: boolean;
}

const Footer: React.FC<FooterProps> = ({ mobile = false }) => {
  const footerLinks = mobile ? styles.footerLinksMobile : styles.footerLinks;
  const INFO_EMAIL = emailScramble.encode("info@flare.space");
  const clickFeedback = () => {
    window.location.href =
      "mailto:" +
      emailScramble.decode(INFO_EMAIL) +
      "?subject=P-Chain Explorer&body=Hey guys, I would like to express my feedback and ideas on P-Chain Explorer...";
  };
  return (
    <>
      <div className={footerLinks}>
        <a onClick={clickFeedback}>Feedback</a>
        {/* <a onClick={openDisclaimer}>Disclaimer</a> */}
        <a href="https://flare.space/privacy" target="_blank" rel="noreferrer">
          Privacy
        </a>
      </div>
      {!mobile && <div className={styles.footer}></div>}
    </>
  );
};

export default Footer;
